import React, { useState, useEffect } from "react";
import { getStyles } from "../util/getStyles";
import Img from "gatsby-image";

const Image = (props) => {
  const [image, setImage] = useState({});
  const [styles, setStyles] = useState({});
  useEffect(() => {
    setImage(props.image.fluid);
    const newStyles = {
      ...getStyles(props),
      margin: props._margin
        ? `${props._margin.top + props._margin.unit} ${
            props._margin.right + props._margin.unit
          } ${props._margin.bottom + props._margin.unit} ${
            props._margin.left + props._margin.unit
          }`
        : "auto",
    };
    setStyles(newStyles);
  }, []);
  return <Img fluid={props.image.fluid} style={styles} />;
};
export default Image;
